import React from 'react';
import { navLinks, programLinks, legalLinks } from '../mock/data';
import FooterBrand from './footer/FooterBrand';
import FooterSocial from './footer/FooterSocial';
import FooterLinks from './footer/FooterLinks';
import FooterContact from './footer/FooterContact';

export default function Footer() {
  const quickLinks = navLinks.map((l) => ({ id: `nav-${l.label}`, label: l.label, href: l.href }));

  return (
    <footer className="bg-[#071E4A] text-slate-300 pt-16 pb-8">
      <div className="container-x grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <FooterBrand />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed">
            Shaping the next generation of pharmacists with 26+ years of excellence. PCI Approved &amp; AKTU Affiliated.
          </p>
          <FooterSocial />
        </div>

        <FooterLinks title="Quick Links" items={quickLinks} />
        <FooterLinks title="Programs" items={programLinks} />
        <FooterContact />
      </div>

      <div className="container-x mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-400">
        <span>© {new Date().getFullYear()} Pharmacy College Azamgarh. All rights reserved.</span>
        <div className="flex gap-5">
          {legalLinks.map((l) => (
            <a key={l.id} href={l.href} className="hover:text-white">{l.label}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}
